import { render, staticRenderFns } from "./UserFloat.vue?vue&type=template&id=727b877c&scoped=true&"
import script from "./UserFloat.vue?vue&type=script&lang=js&"
export * from "./UserFloat.vue?vue&type=script&lang=js&"
import style0 from "./UserFloat.vue?vue&type=style&index=0&id=727b877c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727b877c",
  null
  
)

export default component.exports